import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Снапшот портфелей комьюнити: { status: 'ready', data } | { status: 'not_ready' }
export async function getCommunitySnapshot() {
  const response = await fetchWithAuth(`${backendUrl}/api/portfolios/community/`, { method: 'GET' });
  if (response.status === 404) {
    const body = await response.json().catch(() => ({}));
    if (body.detail === 'snapshot_not_ready') return { status: 'not_ready' };
  }
  if (!response.ok) {
    throw new Error(`Не удалось загрузить портфели комьюнити: HTTP ${response.status}`);
  }
  return { status: 'ready', data: await response.json() };
}
